import type { GameBoard, GamePiece, RawPiece } from '@blind-kings/game-core';
import type { ReactNode } from 'react';
import BkPanel from '../../Components/ui/BkPanel';
import RuleDemoBoard, { RULE_DEMO_BOARD_SIZE } from './RuleDemoBoard';

export type RuleSectionProps = {
  id: string;
  title: string;
  bullets?: string[];
  board?: {
    gameBoard: GameBoard;
    selectedPiece?: GamePiece | RawPiece;
    prompt?: string;
    size?: number;
    aspectRatio?: number;
  };
  children?: ReactNode;
  boardFirst?: boolean;
};

export default function RuleSection({
  id,
  title,
  bullets = [],
  board,
  children,
  boardFirst = true,
}: RuleSectionProps) {
  const copy = (
    <div className="flex min-w-0 flex-1 flex-col gap-3">
      {bullets.length ? (
        <BkPanel className="text-sm text-bk-text/90 sm:text-base">
          <ul className="list-disc space-y-2 pl-5">
            {bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        </BkPanel>
      ) : null}
      {children}
    </div>
  );

  const demo = board ? (
    <div className="shrink-0">
      <RuleDemoBoard
        gameBoard={board.gameBoard}
        seedPiece={board.selectedPiece}
        prompt={board.prompt}
        size={board.size ?? RULE_DEMO_BOARD_SIZE}
        aspectRatio={board.aspectRatio}
      />
    </div>
  ) : null;

  return (
    <section id={id} className="scroll-mt-24 space-y-4">
      <h2 className="border-b border-bk-gold-dim/40 pb-2 text-xl font-bold uppercase tracking-wide text-bk-text sm:text-2xl md:text-3xl">
        {title}
      </h2>
      {demo ? (
        <div
          className={[
            'flex gap-4 sm:items-start',
            boardFirst
              ? 'flex-col sm:flex-row'
              : 'flex-col-reverse sm:flex-row-reverse',
          ].join(' ')}
        >
          {demo}
          {copy}
        </div>
      ) : (
        copy
      )}
    </section>
  );
}
